import * as PIXI from 'pixi.js';
import Config from './Config';
import * as Sounds from './Sounds';

const PLAYER_GROUND_POSIION = Config.GAME_HEIGHT - Config.GROUND_HEIGHT - Config.PLAYER_RADIUS - Config.PLAYER_ALTITUDE;

export default class Player extends PIXI.Container {
  constructor(onDie = () => {}) {
    super();

    this.onDie = onDie;
    this.energy = Config.PLAYER_ENERGY_MAX;
    this.lives = Config.PLAYER_LIVES_INITIAL;
    this.maxVelocity = Config.PLAYER_MAX_VELOCITY_X;
    this.score = 0;
    this.sprite = null;
    this.isInvulnerable = false;
    this.invulnerableTime = 0;
    this.isBlinking = false;
    this.blinkTime = 0;
    this.blinkInterval = 0.2;
    this.elapsedTime = 0;
    this.currentJumpCount = 0;
    this.topPosition = Config.GAME_HEIGHT;

    this.velocity = new PIXI.Point(0, 0);

    // this.position.set(-Config.PLAYER_RADIUS * 2, PLAYER_GROUND_POSIION);

    this.position.set(Config.GAME_WIDTH * Config.PLAYER_ONSCREEN_POSITION, PLAYER_GROUND_POSIION);
    this.positionX = this.position.x;
  }

  onResourcesLoaded() {
    this.sprite = new PIXI.AnimatedSprite(PIXI.Loader.shared.resources['player'].spritesheet.animations['idle']);
    this.sprite.anchor.set(0.5, 0.5);
    this.sprite.loop = true;
    this.sprite.animationSpeed = 36 / 60; // TODO: ???
    this.sprite.play();

    this.addChild(this.sprite);

    // this.graphics = new PIXI.Graphics();
    // this.graphics.beginFill(0x00ff00);
    // this.graphics.drawCircle(0, 0, Config.PLAYER_RADIUS);
    // this.graphics.endFill();
    // this.addChild(this.graphics);
  }

  update(dt, [
    background,
    foreground,
    player,
    ground,
    ...treasures
  ]) {
    this.energy = this.energy + Config.PLAYER_ENERGY_PER_SECOND * dt;
    this.energy = Math.min(this.energy, Config.PLAYER_ENERGY_MAX);
    this.energy = Math.max(this.energy, 0);

    if (!this.isDead) {
      this.score = this.score + Config.PLAYER_SCORE_PER_SECOND * dt;
    }

    if (!this.energy && !this.isDead) {
      this.die();
    }

    this.elapsedTime = (this.elapsedTime + dt) % Config.PLAYER_FLOAT_PERIOD;

    this.maxVelocity = this.maxVelocity + Config.PLAYER_MAX_VELOCITY_X_PER_SECOND * dt;

    this.velocity.x = Math.min(this.maxVelocity, this.velocity.x + Config.PLAYER_ACCELERATION_X * dt);
    this.velocity.y = Math.min(Config.PLAYER_MAX_VELOCITY_Y, this.velocity.y + Config.PLAYER_ACCELERATION_Y * dt);

    this.positionX = this.positionX + this.velocity.x * dt;
    this.position.y = Math.min(PLAYER_GROUND_POSIION, this.position.y + this.velocity.y * dt);

    this.topPosition = Math.min(this.topPosition, this.position.y);

    const isOnGround = this.position.y >= PLAYER_GROUND_POSIION;

    if (isOnGround) {
      this.currentJumpCount = 0;
      this.velocity.y = Math.min(this.velocity.y, 0);
    }

    if (this.sprite && isOnGround) {
      this.sprite.position.y = Config.PLAYER_FLOAT_AMPLITUDE * Math.sin((this.elapsedTime * 2 * Math.PI) / Config.PLAYER_FLOAT_PERIOD);
    }

    if (this.sprite && this.isDead) {
      this.sprite.rotation = this.sprite.rotation + 5 * dt;
      this.sprite.alpha = Math.max(0, this.sprite.alpha - dt / 2);

      return;
    }

    if (this.isInvulnerable) {
      this.invulnerableTime = this.invulnerableTime + dt;

      this.blinkTime += dt;

      if (this.blinkTime >= this.blinkInterval) {
        this.alpha = this.alpha === 1 ? 0.5 : 1;
        this.blinkTime = 0;
      }

      if (this.invulnerableTime >= Config.PLAYER_INVULNERABLE_DURATION) {
        this.isInvulnerable = false;
        this.isBlinking = false;
        this.alpha = 1;
        this.invulnerableTime = 0;
      }
    }
  }

  jump() {
    const canJump = this.currentJumpCount < Config.PLAYER_MAX_JUMP_COUNT;

    if (!canJump) return;

    Sounds.jump.play();

    const newJumpCount = this.currentJumpCount + 1;
    // const isDoubleJump = newJumpCount > 1;

    this.currentJumpCount = newJumpCount;
    this.velocity.y = Config.PLAYER_JUMP_VELOCITY;
  }

  addEnergy(amount) {
    this.energy = Math.min(this.energy + amount, Config.PLAYER_ENERGY_MAX);
  }

  addScore(amount) {
    this.score = this.score + amount;
  }

  onObstacleCollision() {
    if (this.isInvulnerable) return;

    this.lives = Math.max(0, this.lives - 1);

    this.isInvulnerable = true;
    this.isBlinking = true;
    this.blinkTime = 0;

    if (!this.lives) {
      this.die();
    }
  }

  die() {
    this.energy = 0;
    this.isDead = true;
    this.onDie(Math.floor(this.score));
  }

  addLife(amount) {
    this.lives = Math.min(Config.PLAYER_LIVES_MAX, this.lives + amount);
  }
}
